import angular from 'angular';

import summaryWidgetComponent from './activity.component';
import 'ng-infinite-scroll';

export default angular.module('dbm.dashboard.components.widgets.activity', ['infinite-scroll'])
.component('dbmActivityWidget', summaryWidgetComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/activity/index.js